export default __webpack_public_path__ + "static/Mixpanel-5a040ecd96b6666a405c5f09b07ef93f.png";